import { bindActionCreators } from 'redux';
import { createAction } from 'redux-actions';
import actionType from 'redux/modules/pageview/pageviewActionType';
import * as eventUtils from 'redux/utils/eventsUtils';
import eventGroupSvc from 'services/eventGroupService';
import * as notificationActions from 'redux/modules/notification/notificationAction';

const createPageEvent = (event, projectId) => {
  return async (dispatch, getState) => {
    dispatch(createAction(actionType.PAGEVIEW_EVENT_CREATE)());
    const actions = bindActionCreators(notificationActions, dispatch);
    const formated = eventUtils.formatPageviewEvent(event);
    const response = await eventGroupSvc.createEventGroup(formated);
    if (response.ok) {
      actions.updateNotification({type: 'add', name: formated.name}, response.ok);
      dispatch(createAction(actionType.PAGEVIEW_EVENT_CREATED)({data: response.json.data}));
    } else {
      actions.updateNotification(formated.name, response.ok);
    }
  };
};

const updatePageEvent = (event) => {
  return async (dispatch, getState) => {
    dispatch(createAction(actionType.PAGEVIEW_EVENT_CREATE)());
    const actions = bindActionCreators(notificationActions, dispatch);
    const formated = eventUtils.formatPageviewEvent(event);
    const response = await eventGroupSvc.updateEventGroup(formated);
    if (response.ok) {
      actions.updateNotification({type: 'update', name: formated.name}, response.ok);
      dispatch(createAction(actionType.PAGEVIEW_EVENT_CREATED)({data: response.json.data}));
    } else {
      actions.updateNotification(formated.name, response.ok);
    }
  };
};

const getPageviewEvents = (projectId) => {
  return async (dispatch) => {
    dispatch(createAction(actionType.PAGEVIEW_EVENT_FETCHING_EVENTS)());
    const response = await eventGroupSvc.getEventGroups({projectId, type: 'PAGEVIEW'});
    if (response.ok) {
      const events = response.json.data.filter(item => !item.isDeleted);
      dispatch(createAction(actionType.PAGEVIEW_EVENT_FETCH_EVENTS_SUCCESS)({ events }));
    }
  };
};

const updateNewPageviewEvent = (inputs, operators) => {
  return async (dispatch) => {
    dispatch(createAction(actionType.PAGEVIEW_EVENT_UPDATE_NEW)({ inputs, operators }));
  };
};

export {
  createPageEvent,
  getPageviewEvents,
  updatePageEvent,
  updateNewPageviewEvent
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/pageview/pageviewActions.js
 **/